import { PropsWithChildren, useEffect } from 'react';

export function Dialog({
  children,
  onClose,
}: PropsWithChildren<{ onClose: () => void }>) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  return (
    <div
      className="h-screen w-screen fixed left-0 top-0 bg-black/25 z-50 !m-0"
      onClick={(event) => {
        onClose();
        event.stopPropagation();
      }}
    >
      <div
        className="bg-white p-2.5 md:p-10 rounded-lg fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 max-w-[90vw] md:max-w-[75vw] cursor-default"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
